// Consentmo renders its banner inside the open shadow root of <csm-cookie-consent>,
// so theme CSS can't reach it. Inject our overrides into that shadow root instead.
(() => {
  const STYLE_ID = 'makesy-cookie-banner-style';
  const CSS = `
    .csm-cc-btn.cc-allow {
      background: #502c1e !important;
      border-color: #502c1e !important;
      color: #fff !important;
    }
    .csm-cc-btn.cc-settings {
      background: transparent !important;
      border-color: #502c1e !important;
      color: #502c1e !important;
    }
    @media (max-width: 768px) {
      .csm-wrapper .cc-window .csm-cmp-body.isense-csm-cmp-body {
        padding: 12px 16px !important;
        gap: 8px !important;
      }
      .csm-wrapper .cc-window .csm-banner-text-wrapper,
      .csm-wrapper .cc-window .csm-banner-text-wrapper p {
        font-size: 13px !important;
        line-height: 1.4 !important;
        margin: 0 !important;
      }
      .csm-wrapper .cc-window .cc-compliance {
        flex-direction: row !important;
        gap: 8px !important;
        margin: 0 !important;
      }
      .csm-wrapper .cc-window .csm-cc-btn {
        flex: 1 1 0 !important;
        min-height: 36px !important;
        height: 36px !important;
        padding: 6px 12px !important;
        margin: 0 !important;
      }
    }
  `;

  const inject = (host) => {
    const root = host.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  };

  const find = () => document.querySelector('csm-cookie-consent');

  const start = () => {
    const host = find();
    if (host) inject(host);
    // The banner (and its shadow root) is created late, and can be re-created.
    new MutationObserver(() => {
      const el = find();
      if (el) inject(el);
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
